"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_theme_1 = require("@ryerson/frontend.theme");

var ToggleSwitch = function ToggleSwitch(_ref) {
  var id = _ref.id,
      name = _ref.name,
      checked = _ref.checked,
      _onChange = _ref.onChange,
      color = _ref.color,
      disabled = _ref.disabled,
      dataTestId = _ref.dataTestId,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var toggleColor = color || theme.colors.primary.primaryBrand;
  var ToogleContainer = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\tdisplay: inline;\n\t\t.switch {\n\t\t\tposition: relative;\n\t\t\tdisplay: inline-block;\n\t\t\twidth: 46px;\n\t\t\theight: 20px;\n\t\t}\n\n\t\t.switch input {\n\t\t\topacity: 0;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\n\t\t.slider {\n\t\t\tposition: absolute;\n\t\t\tcursor: ", ";\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t\tbackground-color: ", ";\n\t\t\t-webkit-transition: 0.4s;\n\t\t\ttransition: 0.4s;\n\t\t}\n\t\t.slider:before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\ttop: 2.5px;\n\t\t\tleft: 4px;\n\t\t\tbackground-color: ", ";\n\t\t\t-webkit-transition: 0.4s;\n\t\t\ttransition: 0.4s;\n\t\t}\n\n\t\tinput:checked + .slider {\n\t\t\tbackground-color: ", ";\n\t\t}\n\n\t\tinput:focus + .slider {\n\t\t\tbox-shadow: 0 0 1px ", ";\n\t\t}\n\n\t\tinput:checked + .slider:before {\n\t\t\t-webkit-transform: translateX(25px);\n\t\t\t-ms-transform: translateX(25px);\n\t\t\ttransform: translateX(25px);\n\t\t}\n\n\t\t/* Rounded sliders */\n\t\t.slider.round {\n\t\t\tborder-radius: 32px;\n\t\t\tborder: 1px solid\n\t\t\t\t", ";\n\t\t}\n\n\t\t.slider.round:before {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t"])), disabled ? "inherit" : "pointer", disabled ? theme.colors.primary.lighterGray : theme.colors.primary.white, checked ? theme.colors.primary.white : theme.colors.primary.lightGray, toggleColor, toggleColor, !checked ? theme.colors.primary.lightGray : checked ? theme.colors.primary.primaryBrand : "");
  return (0, jsx_runtime_1.jsx)(ToogleContainer, {
    children: (0, jsx_runtime_1.jsxs)("label", {
      className: "switch",
      children: [(0, jsx_runtime_1.jsx)("input", {
        id: id,
        name: name,
        type: "checkbox",
        onChange: function onChange(e) {
          return _onChange(e.target.checked);
        },
        checked: checked,
        disabled: disabled,
        "data-testid": dataTestId
      }), (0, jsx_runtime_1.jsx)("span", {
        className: "slider round"
      })]
    })
  });
};

exports.default = ToggleSwitch;